import React from "react";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { Icon } from "../Icon";
import "./_hoverMenu.scss";

type HoverMenuProps = {
    iconContent?: React.ReactNode;
    hoverText?: string;
    items: { icon?: IconName, title?: string, onClick?: () => void, content?: React.ReactNode }[];
    className?: string;
}

export const HoverMenu: React.FC<HoverMenuProps> = ({ iconContent, items, hoverText, className }) => {

    return (
        <div className="hover-menu-wrapper">
            <div className={`hover-menu-icon ${className || ''}`} title={hoverText}>
                {iconContent}
            </div>

            <div className={`hover-menu`}>
                {items.map((it, i) => {
                    return (
                        <div key={i} className="hover-menu-item" onClick={it.onClick}>
                            {it.content}
                            {it.icon && <Icon name={it.icon} className="mr-2" />}
                            {it.title && <div>{it.title}</div>}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};